/** Hosted Pivony MCP server; users add it as a connector in Claude or another MCP client. */
export const MCP_SERVER_URL = "https://mcp.pivony.com/mcp";

export const MCP_SALES_EMAIL = "sales@pivony.com";

/** MCP Pro list price, per organization per month (pivony-api api/utils/mcp_pro.py). */
export const MCP_PRO_MONTHLY_PRICE_USD = 1200;

/** Tools the hosted server offers (pivony-mcp gateway/src/pivony_mcp_gateway/server.py). */
export const MCP_TOOLS = [
  { name: "pivony_list_dashboards", descKey: "mcp_connector.tool_list_dashboards" },
  { name: "pivony_get_dashboard_filters", descKey: "mcp_connector.tool_get_dashboard_filters" },
  { name: "pivony_get_cx_metrics", descKey: "mcp_connector.tool_get_cx_metrics" },
  { name: "pivony_get_trends", descKey: "mcp_connector.tool_get_trends" },
  { name: "pivony_get_topic_trends", descKey: "mcp_connector.tool_get_topic_trends" },
  { name: "pivony_get_root_causes", descKey: "mcp_connector.tool_get_root_causes" },
  { name: "pivony_list_reviews", descKey: "mcp_connector.tool_list_reviews" },
  { name: "pivony_search_reviews", descKey: "mcp_connector.tool_search_reviews" },
  { name: "pivony_ask_advisor", descKey: "mcp_connector.tool_ask_advisor" },
  { name: "pivony_get_usage", descKey: "mcp_connector.tool_get_usage" },
];

/** OAuth authorize parameters the consent page carries to the API. */
export const OAUTH_CONSENT_PARAMS = [
  "response_type",
  "client_id",
  "redirect_uri",
  "scope",
  "state",
  "code_challenge",
  "code_challenge_method",
  "resource",
];

export async function copyTextToClipboard(text) {
  if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
    await navigator.clipboard.writeText(text);
    return true;
  }
  const area = document.createElement("textarea");
  area.value = text;
  area.style.position = "fixed";
  area.style.left = "-9999px";
  document.body.appendChild(area);
  area.select();
  const ok = document.execCommand("copy");
  document.body.removeChild(area);
  return ok;
}
